import {getApi} from '../../modules/common/utils/api'

const api = getApi('reservation')
const default_api = getApi('default')

export function postShareableCalendarView(data) {
  return api.post(`/v1/shareable_calendar_views`, data)
}

export function putShareableCalendarView(data) {
  return api.put(`v1/shareable_calendar_views`, data)
}

export function deleteShareableCalendarView(data) {
  return api.delete(`v1/shareable_calendar_views`, {data})
}

export function getAdvanceOptionRange(action_id) {
  return default_api.get(`v3/actions/${action_id}/fields?is_shareable_action_fields=true`)
}

export function getShareableCalendarViews(user_id) {
  return api.post(`/v1/shareable_calendar_views/shareable_user_views`, {user_id: user_id})
}

export function getDisplayFields(group_id, params) {
  return default_api.post(`/v3/entities/${group_id}/shareable_calendar_display_fields`, {
    action_ids: params,
  })
}
